import { render, staticRenderFns } from "./PropertyCard.vue?vue&type=template&id=4f348d7a&scoped=true"
import script from "./PropertyCard.vue?vue&type=script&lang=js"
export * from "./PropertyCard.vue?vue&type=script&lang=js"
import style0 from "./PropertyCard.vue?vue&type=style&index=0&id=4f348d7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f348d7a",
  null
  
)

export default component.exports